import React from "react";
import { konten, beranda, tentang, media, pengaturan } from "../../../routes";
import Links from "./Links";

function Menu() {
	return (
		<>
			<span className="flex items-center py-3 pl-8 text-base font-medium text-gray-500">
				Konten
			</span>
			<Links routes={konten} />

			<span className="flex items-center py-3 pl-8 text-base font-medium text-gray-500">
				Halaman Utama
			</span>
			<Links routes={beranda} />
			<Links routes={tentang} />

			<span className="flex items-center py-3 pl-8 text-base font-medium text-gray-500">
				Media
			</span>
			<Links routes={media} />

			<span className="flex items-center py-3 pl-8 text-base font-medium text-gray-500">
				Pengaturan
			</span>
			<Links routes={pengaturan} />
		</>
	);
}

export default Menu;
